<ng-container *ngIf="field.readonly">
  <crm-row>
    <header>{{ field.name }}</header>
    <main>{{ readonlyValue$ | async }}</main>
  </crm-row>
</ng-container>

<ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
  <div class="form-field checkbox">
    <mat-checkbox [formControlName]="field.key" color="primary">{{ field.name }}</mat-checkbox>
  </div>
</ng-container>
